import { Button, Checkbox, Form, FormInstance, Skeleton, Space } from 'antd';

import { AnyOfFilterModel, RenderOptionsList } from './core';

const requiredRules = [
  { required: true, message: 'Поле обязательно для заполнения' },
];

type OneOfFilterFormProps = {
  form: FormInstance<{ value: AnyOfFilterModel['value'] }>;
  options: RenderOptionsList;
  value?: AnyOfFilterModel['value'];
  onSubmit: (value: AnyOfFilterModel['value']) => void;
  onReset: () => void;
};
// eslint-disable-next-line mobx/missing-observer
export const AnyOfFilterForm = ({
  form,
  options,
  value,
  onSubmit,
  onReset,
}: OneOfFilterFormProps) => {
  const handleSubmit = ({ value }: { value: AnyOfFilterModel['value'] }) => {
    onSubmit(value);
  };

  const handleReset = () => {
    onReset();
  };

  const optionsList =
    options.length === 0 ? (
      <Skeleton style={{ minWidth: '100%' }} active />
    ) : (
      options.map(({ label, value }) => (
        <Checkbox value={value} key={value}>
          {label}
        </Checkbox>
      ))
    );

  return (
    <div className="ag-filter">
      <Form
        layout="vertical"
        className="ag-filter-wrapper ag-focus-managed"
        form={form}
        fields={[{ name: 'value', value }]}
        onFinish={handleSubmit}
        onReset={handleReset}
      >
        <div className="ag-filter-body-wrapper ag-simple-filter-body-wrapper">
          <div
            className="ag-filter-body"
            role="presentation"
            aria-hidden="false"
          >
            <div
              role="presentation"
              className="ag-labeled ag-label-align-left ag-number-field ag-input-field ag-filter-from ag-filter-filter"
              aria-hidden="false"
            >
              <div
                style={{
                  width: '100%',
                  maxHeight: 500,
                  overflowY: 'auto',
                }}
              >
                <Form.Item name="value" rules={requiredRules} noStyle>
                  <Checkbox.Group style={{ width: '100%' }}>
                    <Space
                      direction="vertical"
                      style={{ width: '100%', padding: 4 }}
                    >
                      {optionsList}
                    </Space>
                  </Checkbox.Group>
                </Form.Item>
              </div>
            </div>
          </div>

          <Space direction="vertical" style={{ width: '100%', marginTop: 8 }}>
            <Button type="primary" htmlType="submit" block>
              Найти
            </Button>
            <Button htmlType="reset" block>
              Сбросить
            </Button>
          </Space>
        </div>
      </Form>
    </div>
  );
};
